export const OfferEvaluationResult = {
  WINNER: "winner",
  NON_WINNER: "non_winner",
  NON_COMPLIANT: "non_compliant",
};

export const OfferEvaluationResultLabel = {
  [OfferEvaluationResult.WINNER]: "Câștigător",
  [OfferEvaluationResult.NON_WINNER]: "Necâștigător",
  [OfferEvaluationResult.NON_COMPLIANT]: "Neconform",
};

export const OfferEvaluationResultOptions = Object.values(
  OfferEvaluationResult,
).map((value) => ({ value, label: OfferEvaluationResultLabel[value] }));
